export default {
  id: 7,
  title: 'Target #7 - Leafy Trail',
  url: 'https://cssbattle.dev/play/7',
  colors: ['#0B2429', '#F3AC3C', '#998235', '#1A4341'],
  solution:
    '<a><style>body{background:#0B2429}a{position:fixed;top:75;right:75;width:150;height:150;background:#F3AC3C;border-radius:100px 0;box-shadow:-50px 0 #998235,-100px 0 #1A4341}</style>',
}
